import { render } from "./ProfileCompleteness.vue?vue&type=template&id=61374ee9&scoped=true"
import script from "./ProfileCompleteness.vue?vue&type=script&lang=js"
export * from "./ProfileCompleteness.vue?vue&type=script&lang=js"

import "./ProfileCompleteness.vue?vue&type=style&index=0&id=61374ee9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61374ee9"]])

export default __exports__